import React from "react"

import { useContext } from "react"
import {
  Box,
  Grid,
  Heading,
  Container,
  Flex,
  Image,
} from "@theme-ui/components"
import { useInView } from "react-intersection-observer"
import { GatsbyImage } from "gatsby-plugin-image"
import VideoStream from "./VideoStream"
import ArrowDown from "../images/scroll-arrow-white.svg"
import ArrowMobile from "../images/arrowMobile.svg"
import MobileBanner from "./mobileBanner"
import { InboundLink } from "./link"
import { getPagePath } from "../utils/path"
import { get } from "theme-ui"
import { LanguageSwitcherContext } from "../context/languageSwitcherContext"
import { motion } from "framer-motion"
const IntroVideo = ({ block, media, contactPage }) => {
  const locale = useContext(LanguageSwitcherContext).activeLocale
  const arrowVariants = {
    hidden: { y: -300, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 1.2 } },
  }
  const [ref, inView] = useInView({
    triggerOnce: true,
  })
  const minHeight = "100%"
  return (
    <Container
      variant="fw"
      sx={{
        p: "0px!important",
        mx: "0px!important",
        position: "relative",
        mt: [4, 4, 4, 7],
        height: "600px",
        minHeight: ["50vh", "100vh", "100vh", "600px"],
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: ["block", "block", "none", "none"],
          a: {
            textDecoration: "none",
          },
        }}
      >
        <InboundLink to={getPagePath(contactPage, locale)}>
          <MobileBanner />
        </InboundLink>
      </Box>
      {media.mimeType === "video/mp4" && (
        <VideoStream
          minHeight={minHeight}
          muxPlaybackId={media.video.muxPlaybackId}
          customData={media.customData}
          aspectRatio={"1/1"}
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 1,
          }}
        />
      )}

      <Grid
        columns={[1, 2]}
        gap={[5, 2, 3, 10]}
        sx={{
          position: "absolute",
          top: [5, 5, 5, 0],
          left: 0,
          zIndex: 2,

          p: [4, 4, 4, 5],
        }}
      >
        <Box
          sx={{
            width: ["100%", "70%"],
            fontSize: [4, 5, 5, "34px"],

            lineHeight: "heading",
            fontWeight: 400,
            color: "white",
            p: {
              m: 0,
            },
          }}
          dangerouslySetInnerHTML={{ __html: block.columnLeft }}
        />
        <Box
          sx={{
            width: ["100%", "70%"],

            fontSize: [2, 2, "21px"],
            fontFamily: "heading",

            fontWeight: 400,
            color: "white",
            p: {
              m: 0,
            },
          }}
          dangerouslySetInnerHTML={{ __html: block.columnRight }}
        />
      </Grid>
      <Box
        sx={{
          position: "absolute",
          bottom: ["5px", "5px", "10px", "10px"],
          left: "50%",
          textAlign: "center",
          zIndex: 2,
          mt: 3,
        }}
      >
        <motion.div
          ref={ref}
          variants={arrowVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          <Image
            sx={{ zIndex: 2, display: ["none", "none", "block", "block"] }}
            src={ArrowDown}
          />
          <Image
            sx={{ zIndex: 2, display: ["block", "block", "none", "none"] }}
            src={ArrowMobile}
          />
        </motion.div>
      </Box>
    </Container>
  )
}

export default IntroVideo
